import { render, staticRenderFns } from "./FormulariobpPage.vue?vue&type=template&id=97221606"
import script from "./FormulariobpPage.js?vue&type=script&lang=js&external"
export * from "./FormulariobpPage.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports